"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum;
(function (TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum) {
    TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum["UnknownEntitlementRelationOperation"] = "UNKNOWN_ENTITLEMENT_RELATION_OPERATION";
    TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum["Equal"] = "EQUAL";
    TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum["NotEqual"] = "NOT_EQUAL";
})(TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum = exports.TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum || (exports.TableauQuerypolicyV1CreateEntitlementRelationCommandOperationEnum = {}));
function TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSON(json) {
    return TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSONTyped(json, false);
}
exports.TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSON = TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSON;
function TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'luid': !runtime_1.exists(json, 'luid') ? undefined : json['luid'],
        'parentLuid': !runtime_1.exists(json, 'parent_luid') ? undefined : json['parent_luid'],
        'entitlementRelationGroupLuid': !runtime_1.exists(json, 'entitlement_relation_group_luid') ? undefined : json['entitlement_relation_group_luid'],
        'entitlementTableColumnLuid': !runtime_1.exists(json, 'entitlement_table_column_luid') ? undefined : json['entitlement_table_column_luid'],
        'dataTableColumnLuid': !runtime_1.exists(json, 'data_table_column_luid') ? undefined : json['data_table_column_luid'],
        'operation': !runtime_1.exists(json, 'operation') ? undefined : json['operation'],
        'commandLuid': !runtime_1.exists(json, 'command_luid') ? undefined : json['command_luid'],
    };
}
exports.TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSONTyped = TableauQuerypolicyV1CreateEntitlementRelationCommandFromJSONTyped;
function TableauQuerypolicyV1CreateEntitlementRelationCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'luid': value.luid,
        'parent_luid': value.parentLuid,
        'entitlement_relation_group_luid': value.entitlementRelationGroupLuid,
        'entitlement_table_column_luid': value.entitlementTableColumnLuid,
        'data_table_column_luid': value.dataTableColumnLuid,
        'operation': value.operation,
        'command_luid': value.commandLuid,
    };
}
exports.TableauQuerypolicyV1CreateEntitlementRelationCommandToJSON = TableauQuerypolicyV1CreateEntitlementRelationCommandToJSON;
